import styled from "styled-components";
import colors from "../../../theme/colors";

interface IDesktopIcon {
    onClick: any;
    previewFor: string;
    previewSelected: string;
}

interface IIconContainer {
    previewFor: string;
    previewSelected: string;
}

const IconContainer = styled.span<IIconContainer>`
    display: flex;
    align-items: center;
    cursor: pointer;

    svg {
        fill: ${(props) => props.previewFor === props.previewSelected ? colors.white : colors.placeholder};
    }
`;

const DesktopIcon: React.FC<IDesktopIcon> = ({onClick, previewFor, previewSelected}) => {
    return (
        <IconContainer onClick={onClick} previewFor={previewFor} previewSelected={previewSelected}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M25.3333 5.33317H6.66659C5.19383 5.33317 3.99992 6.52708 3.99992 7.99984V18.6665C3.99992 20.1393 5.19383 21.3332 6.66659 21.3332H25.3333C26.806 21.3332 27.9999 20.1393 27.9999 18.6665V7.99984C27.9999 6.52708 26.806 5.33317 25.3333 5.33317ZM6.66659 2.6665C3.72107 2.6665 1.33325 5.05432 1.33325 7.99984V18.6665C1.33325 21.612 3.72107 23.9998 6.66659 23.9998H14.6666V26.6665H10.6666V29.3332L21.3333 29.3332V26.6665H17.3333V23.9998H25.3333C28.2788 23.9998 30.6666 21.612 30.6666 18.6665V7.99984C30.6666 5.05432 28.2788 2.6665 25.3333 2.6665H6.66659Z" />
            </svg>
        </IconContainer>
    )
}

export default DesktopIcon;